module.exports = __webpack_public_path__ + "img/line.94a15ca0.svg";